import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import NotificationSettings from '../components/NotificationSettings';
import './SettingsPage.css';

export default function SettingsPage() {
  const { user, logout } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState('notifications');

  const tabs = [
    { id: 'notifications', label: 'Notifications', icon: '🔔' },
    { id: 'account', label: 'Account', icon: '👤' }
  ];

  const renderNotificationsTab = () => (
    <div className="settings-tab-content">
      <h3>Notification Settings</h3>
      <p>Configure how you receive notifications for quote updates.</p>
      <NotificationSettings />
    </div>
  );

  const renderAccountTab = () => (
    <div className="settings-tab-content">
      <h3>Account Information</h3>
      
      <div className="account-info">
        <div className="info-item">
          <span className="info-label">Username:</span>
          <span className="info-value">{user?.login || user?.username || 'N/A'}</span>
        </div>
        <div className="info-item">
          <span className="info-label">Database:</span>
          <span className="info-value">{user?.database || user?.db || 'N/A'}</span>
        </div>
        <div className="info-item">
          <span className="info-label">User ID:</span>
          <span className="info-value">{user?.id || 'N/A'}</span>
        </div>
      </div>

      <div className="account-actions">
        <button 
          className="btn btn-danger"
          onClick={logout}
        >
          Logout
        </button>
      </div>
    </div>
  );

  const renderTabContent = () => {
    switch (activeTab) {
      case 'notifications':
        return renderNotificationsTab();
      case 'account':
        return renderAccountTab();
      default:
        return renderNotificationsTab();
    }
  };

  return (
    <div className="settings-page">
      <div className="settings-header">
        <div className="header-navigation">
          <Link to="/quotes" className="back-link">
            ← Back to Quotes
          </Link>
        </div>
        <h1>Settings</h1>
        <p>Configure your quote portal preferences and integrations</p>
      </div>

      <div className="settings-container">
        <nav className="settings-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`settings-tab ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </nav>

        <main className="settings-content">
          {renderTabContent()}
        </main>
      </div>
    </div>
  );
}